/* ++++++++++ --------------- EXPORT : DATA REVENUE : STYLES --------------- ++++++++++ */
export default theme => ({
    revenue:{

    }
});
